<style lang="less">
  .m-box {
    background: #FFFFFF;
    margin: 0 0.3rem;
    margin-bottom: 0.6rem;
    padding: 0.4rem;
    font-size: 0.30rem;
  }

  .m-box h3 {
    font-size: 0.36rem;
    color: #C1272D;
    text-align: center;
  }

  .btn-group {
    /* display: box; */
    display: -ms-flexbox;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .btn-group button {
    width: 2.86rem;
    text-align: center;
  }

  .van-button--gray {
    background: #9B9B9B;
    border-radius: 0.16rem;
    color: #fff;
  }

</style>

<template>
  <div class="page page-my bg-red">
    <div v-if="finalRes > 0" class="page__inner">
      
      <my-awards-notice v-if="isAfter(finalRes)" />

      <div class="sect-wrap">
        <my-steps />
      </div>

      <!-- <div class="m-box">
      <h3>恭喜您获得XXX奖</h3>
      <br>
      <p>请在12月30日 24:00 之前填写你的个人信息，以便我们给你邮寄奖品以及发放相关服务权益。过期未提交信息视为自动弃权，为了您的权益，请及时提交个人信息，领取奖品！</p>
      <br>
      <button class="van-button van-button--danger van-button--big van-button--block"><span class="van-button__text">立即填写</span></button>
    </div> -->

      <!-- 
    <div class="m-box">
      <h3>您感觉本次活动怎么样呢？</h3>
      <br>
      <p>下次活动的举办将根据您的支持度择期举办，您什么意见？</p>
      <br>
      <div class="btn-group">
        <button class="van-button van-button--danger van-button--big"><span class="van-button__text">助力举办</span></button>
        <button class="van-button van-button--gray van-button--big"><span class="van-button__text">吐槽活动</span></button>
      </div>
    </div> -->

      <div v-if="isAfter(finalBegin)" class="sect-wrap">
        <my-final-games />
      </div>

      <div class="sect-wrap">
        <my-pre-games />
      </div>

       <ad-vip-audio />
    </div>
    <div v-else class="page__inner"><txt-loading /></div>
  </div>
</template>

<script>
  import {
    mapState,
    mapGetters,
    mapActions
  } from 'vuex'
  import MySteps from './steps/index'
  import MyPreGames from './pre-games/index'
  import MyFinalGames from './final-games/index'
    import MyAwardsNotice from './awards/notice'

  export default {
    components: {
      [MySteps.name]: MySteps,
      [MyPreGames.name]: MyPreGames,
      [MyFinalGames.name]: MyFinalGames,
      [MyAwardsNotice.name]: MyAwardsNotice
    },
    computed: {
      ...mapState(['cupList']),
      ...mapGetters(['realityCupId', 'isAfter', 'nowTime', 'finalBegin', 'finalRes', 'awardTime']),
      ...mapGetters('reality', ['allActions'])
    },
    methods: {
      ...mapActions(['loadRealityCupId', 'loadDkCupPlayers']),
      ...mapActions('reality', {
        loadFinalGames: 'loadGames'
      })
    },
    async created() {
      if (!this.realityCupId) {
        await this.loadRealityCupId()
      }

      // 加载决赛记录
      if(this.isAfter(this.finalBegin)) {
        this.loadFinalGames({
          cupId: this.realityCupId
        })
      }
      // console.log(JSON.stringify(games));

      this.loadDkCupPlayers()
    }
  };

</script>
